import React from "react"

import { CreateModal } from "@components/Page"
import { getFormSchema} from "@components/Form"

import getCreateInputs from "./helpers/getCreateInputs"

const createOperation = "organizations/CreatePartnerOrganization"
const getCreateSchema = getFormSchema(createOperation)

const LABEL_ENTITY = "Fund"
const LABEL_ADD = `Add ${LABEL_ENTITY}`


const OrganizationCreateModal = ({ modal, table }) => {
  const createInputs = getCreateInputs()
  const createSchema = getCreateSchema(createInputs)

  return (
    <CreateModal
      modal={modal}
      table={table}
      title={LABEL_ADD}
      entity={LABEL_ENTITY}
      schema={createSchema}
      operation={createOperation}
    />
  )
}

export default OrganizationCreateModal
